import React, { Fragment, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Signin from "./components/authentication/Signin";
import OperationCenter from "./components/pages/OperationCenter";
import Events from "./components/pages/Events";
import Communication from "./components/pages/Communication";
import Analysis from "./components/pages/Analysis";
import Assessment from "./components/pages/Assessment";
import UmiHeader from "./components/utils/UmiHeader";
import CRA from "./components/pages/CRA";
import GroundData from "./components/pages/GroundData";
import HazardMapping from "./components/pages/HazardMapping";
import CaV from "./components/pages/CaV";
import Rainfall from "./components/pages/Rainfall";
import Earthquake from "./components/pages/Earthquake";
import SurficialMarkers from "./components/pages/SurficialMarkers";
import Moms from "./components/pages/Moms";
import Resources from "./components/pages/Resources";
import Feedback from "./components/pages/Feedback";
import ChangePassword from "./components/utils/ChangePassword";
import ProfileSettings from "./components/utils/ProfileSettings";
import Bulletin from "./components/utils/Bulletin";

const App = (props) => {
  const [nav, setNav] = useState(null);
  const Header = () => {
    let location = window.location.pathname;

    if (location !== "/signin" && location !== "" && location !== "/") {
      if (localStorage.getItem("umi_credentials") !== null) {
        return <UmiHeader />;
      }
    } else {
      if (localStorage.getItem("umi_credentials") !== null) {
        window.location = "/opcen";
      }
    }
  };

  return (
    <Fragment>
      <SnackbarProvider>
        <Router homepage="">
          {Header()}
          <Routes>
            <Route exact path="" element={<Signin />} />
            <Route exact path="/signin" element={<Signin />} />
            <Route exact path="/feedback" element={<Feedback />} />
          </Routes>

          {localStorage.getItem("umi_credentials") != null && (
            <Routes>
              <Route exact path="/opcen" element={<OperationCenter />} />
              <Route exact path="/bulletin" element={<Bulletin />} />
              <Route exact path="/events" element={<Events />} />
              <Route exact path="/communication" element={<Communication />} />
              <Route exact path="/analysis" element={<Analysis />} />
              <Route exact path="/assessment" element={<Assessment />} />
              <Route exact path="/cra" element={<CRA />} />
              <Route exact path="/ground_data" element={<GroundData />} />
              <Route
                exact
                path={`/hazard_map`}
                element={<HazardMapping />}
              />
              <Route exact path="/cav" element={<CaV />} />
              <Route exact path="/rainfall" element={<Rainfall />} />
              <Route exact path="/earthquake" element={<Earthquake />} />
              <Route exact path="/resources" element={<Resources />} />
              <Route
                exact
                path="/change-password"
                element={<ChangePassword />}
              />
              <Route
                exact
                path="/profile-settings"
                element={<ProfileSettings />}
              />
              <Route
                exact
                path="/surficial_markers"
                element={<SurficialMarkers />}
              />
              <Route exact path="/moms" element={<Moms />} />
              <Route exact path="/bulletin" element={<Bulletin />} />
            </Routes>
          )}
        </Router>
      </SnackbarProvider>
    </Fragment>
  );
};

export default App;
